import React from 'react'
import { Modal } from 'react-bootstrap'

const LicenseErrorPopup = ({show,handleClose,msg}) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header className="save-closing">
        <Modal.Title className="text-white save-close-title">License Format</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <p>{msg}</p>
      </Modal.Body>
      
    </Modal>
  )
}

export default LicenseErrorPopup